import React from 'react';
import { Alert } from 'react-bootstrap';
import { 
  AiOutlineCheckCircle, 
  AiOutlineExclamationCircle, 
  AiOutlineWarning, 
  AiOutlineInfoCircle 
} from 'react-icons/ai';
import '../styles/AlertContainer.css';

const AlertContainer = ({ alerts, onRemove }) => {
  if (!alerts.length) return null;

  const getIcon = (type) => {
    const iconProps = { size: 18, className: 'me-2' };
    
    switch (type) {
      case 'success':
        return <AiOutlineCheckCircle {...iconProps} />;
      case 'danger':
        return <AiOutlineExclamationCircle {...iconProps} />;
      case 'warning':
        return <AiOutlineWarning {...iconProps} />;
      case 'info':
      default:
        return <AiOutlineInfoCircle {...iconProps} />;
    }
  };

  return (
    <div className="alert-container">
      {alerts.map(alert => (
        <Alert
          key={alert.id}
          variant={alert.type}
          dismissible={alert.dismissible}
          onClose={() => onRemove(alert.id)}
          className={`custom-alert alert-${alert.type}`}
        >
          <div className="d-flex align-items-center">
            {getIcon(alert.type)}
            <div className="flex-grow-1">
              {alert.title && (
                <Alert.Heading className="h6 mb-1">
                  {alert.title}
                </Alert.Heading>
              )}
              <div>{alert.message}</div>
              {alert.details && (
                <small className="text-muted d-block mt-1">
                  {alert.details}
                </small>
              )}
            </div>
            {alert.action && (
              <button
                className="btn btn-sm btn-outline-secondary ms-2"
                onClick={alert.action.onClick}
              >
                {alert.action.label}
              </button>
            )}
          </div>
        </Alert>
      ))}
    </div>
  );
};

export default AlertContainer;